import { type CoreCustomerResponseList } from '@flecto/types'

import { api } from '../../../services/api'

export type GetAllCustomersOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  sort?: 'id'
}

/**
 * Get all user logged customers.
 *
 * @endpoint GET /api/saas/me/customers
 * @scope saas
 * @see https://flecto.dev/api-4724208
 */
export async function getAllCustomers(
  options?: GetAllCustomersOptions
): Promise<CoreCustomerResponseList> {
  const response = await api.get('/api/saas/me/customers', { params: options })

  return response.data
}

